import { IRawStyle } from "@fluentui/react";
import { createContext } from "react";

import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { NoteSubjectType } from "../../../../types/NoteSubjectType";
import { NoteItem } from "./NoteItem";

export interface INotesStateContext {
    notes: NoteItem[];
    setNotes: (notes: NoteItem[]) => void;
    isLoading: boolean;
    subjectId: string;
    sourceIds: string[];
    subjectType: NoteSubjectType;
    isDeleteSupported: boolean;
    isHeader: boolean;
    isInlineCreateSupported: boolean;
    style?: IRawStyle;
    accessRights: SprintAccessRight[];
    disabled?: boolean;
    renderBadge?: (note: NoteItem) => JSX.Element;
}

const defaultNotesStateContext = {} as INotesStateContext;

export const NotesStateContext = createContext<INotesStateContext>(defaultNotesStateContext);
